import React, { useState } from "react";
import { Button, Grid } from "@material-ui/core";
import {
  facebook,
  instagram,
  twitter,
  linkedin,
  planefill,
} from "../../../resources/images/index";
import {
  LogHeader,
  MainHeading,
  InnerHeader,
} from "../../../components/common/Header/index";

import Cards from "../../../components/common/Cards";

const events = [
  {
    picture: "/static/images/cards/contemplative-reptile.jpg",
    subheading: "Event Title",
    cardtext: "SAT, APR 18, 2021",
    date: "This Saturday",
    time: "10 AM PST",
  },
  {
    picture: "/static/images/cards/contemplative-reptile.jpg",
    subheading: "Event Title",
    cardtext: "SAT, APR 18, 2021",
    date: "This Saturday",
    time: "10 AM PST",
  },
  {
    picture: "/static/images/cards/contemplative-reptile.jpg",
    subheading: "Event Title",
    cardtext: "SAT, APR 18, 2021",
    date: "This Saturday",
    time: "10 AM PST",
  },
  {
    picture: "/static/images/cards/contemplative-reptile.jpg",
    subheading: "Event Title",
    cardtext: "SAT, APR 18, 2021",
    date: "This Saturday",
    time: "10 AM PST",
  },
  {
    picture: "/static/images/cards/contemplative-reptile.jpg",
    subheading: "Event Title",
    cardtext: "SAT, APR 18, 2021",
    date: "This Saturday",
    time: "10 AM PST",
  },
  {
    picture: "/static/images/cards/contemplative-reptile.jpg",
    subheading: "Event Title",
    cardtext: "SAT, APR 18, 2021",
    date: "This Saturday",
    time: "10 AM PST",
  },
];
function LogAllUpcomingEvents(props) {
  return (
    <div className="latestReleaseDetailWrapper">
      <LogHeader />
      <MainHeading headerSubHeading="All Upcoming Events">
        <div className="popupBody eventsWrapper">
          <div className="cards">
            <Grid container spacing={3}>
              {events.map((item, index) => (
                <Grid key={index} item md={4}>
                  <Cards
                    picture={item.picture}
                    subheading={item.subheading}
                    cardtext={item.cardtext}
                    date={item.date}
                    time={item.time}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      </MainHeading>
    </div>
  );
}

export default LogAllUpcomingEvents;
